import React from 'react';
import { ImageSquare } from 'phosphor-react';
import { SkinPhoto } from '../../types/entities';
import { formatDate } from '../../utils/date';
import LazyImage from '../ui/LazyImage';

interface SkinPhotoCardProps {
  photo: SkinPhoto;
  isLatest: boolean;
  onClick: () => void;
}

function SkinPhotoCard({ photo, isLatest, onClick }: SkinPhotoCardProps) {
  return (
    <button
      onClick={onClick}
      className="relative rounded-2xl overflow-hidden aspect-square bg-nude-100 dark:bg-gray-800 hover:scale-[1.02] active:scale-[0.97] transition-transform shadow-soft"
    >
      <LazyImage
        src={photo.photoUrl}
        alt={`Pele em ${formatDate(photo.photoDate)}`}
        className="w-full h-full"
        imgClassName="w-full h-full object-cover"
        fallback={<ImageSquare className="w-8 h-8 text-nude-300 dark:text-gray-600" />}
      />

      {isLatest && (
        <div className="absolute top-2 left-2 px-2 py-0.5 bg-blush-400 rounded-full">
          <p className="text-white text-[10px] font-bold">Mais recente</p>
        </div>
      )}

      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent px-3 py-2.5">
        <p className="text-white text-xs font-semibold">{formatDate(photo.photoDate)}</p>
        {photo.notes && (
          <p className="text-white/70 text-[11px] leading-snug mt-0.5 line-clamp-2">
            {photo.notes}
          </p>
        )}
      </div>
    </button>
  );
}

interface SkinPhotoGridProps {
  photos: SkinPhoto[];
  onSelect: (photo: SkinPhoto) => void;
}

export default function SkinPhotoGrid({ photos, onSelect }: SkinPhotoGridProps) {
  return (
    <div className="stagger grid grid-cols-2 gap-3">
      {photos.map((photo, idx) => (
        <SkinPhotoCard
          key={photo.id}
          photo={photo}
          isLatest={idx === 0}
          onClick={() => onSelect(photo)}
        />
      ))}
    </div>
  );
}
